<div class="modal-header">
    <span class="pull-right">
        <button class="btn btn-default btn-xs" (click)="close()"><i class="glyphicon glyphicon-remove"></i></button>
      </span>
  <span>
    <h4 class="modal-title">{{ request.title }}</h4>
  </span> 
</div>

<div class="modal-body" [formGroup]="reviewForm">
  <div class="form-horizontal">
    <div class="form-group">
      <label class="control-label col-sm-4">Notes</label>
      <div class="col-sm-8">
          <textarea class="form-control" maxlength="2000" rows="20" formControlName="comment"></textarea>
      </div>
    </div>  
  </div>
</div>

<div class="modal-footer">
    <button class="btn btn-primary" (click)="completeReview()" [disabled]="reviewForm.invalid">Send to Experiment Creation</button>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-review-modal/request-review-modal.component.html